import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import DashboardLayoutEngenharia from './layouts/dashboardEngenharia';
import DashboardLayoutMontagem from './layouts/dashboardMontagem';
import DashboardVendas from './layouts/dashboardVendas';
import DashboardOs from './layouts/dashboardOs';
import DashboardLeads from './layouts/dashboardLeads';
import SimpleLayout from './layouts/simple';
import PrivateRoute from './pages/PrivateRoute';

//

import Home from './pages/Home';
import Page404 from './pages/Page404';
import SemAutorizacao from './pages/SemAutorizacao';
import LogsPage from './pages/LogsPage';
import Login from './pages/LoginPage';
import Modulos from './pages/Modulos';

import Produtos from './pages/Produtos';
import Clientes from './pages/Clientes';
import Kits from './pages/Kits';
import Propostas from './pages/Propostas';
import Chamados from './pages/Chamados';
import Kanban from './pages/Kanban';
import ConfiguracaoPage from './pages/ConfiguracaoPage';
import Agenda from './pages/Agenda';
import Relatorios from './pages/Relatorios';
// Leads
import HomeLeads from './pages/Leads/Dashboard/Home';
import HomeEngenharia from './pages/HomeEngenharia';
import HomeMontagem from './pages/HomeMontagem';

// Vendas
import DashboardPage from './pages/Vendas/Dashboard/DashboardPage';
import Vendas from './pages/Vendas/Vendas/Vendas';
import Receitas from './pages/Vendas/Receitas/Receitas';
import Despesas from './pages/Vendas/Despesas/Despesas';
import Cadastros from './pages/Vendas/Cadastros/Cadastros';
import Estoque from './pages/Vendas/Estoque/Estoque';
// OS


import HomeOs from './pages/Os/Dashboard/HomeOs';
import Os from './pages/Os/Os/Os';
import KanbanOs from './pages/Os/Kanban/Kanban';
import Cronograma from './pages/Os/Cronograma/Cronograma';





// temp
// import Pdf from './pages/Pdf'

// ----------------------------------------------------------------------

export default function Router() {
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));

  const routes = useRoutes([
    {
      path: '/',
      element: <Login />,
      index: true,
    },
    {
      path: '/login',
      element: <Login />,
    },

    // CRM
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'home',
          element: <PrivateRoute element={<Home />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'clientes',
          element: <PrivateRoute element={<Clientes />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'produtos',
          element: <PrivateRoute element={<Produtos />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'kits',
          element: <PrivateRoute element={<Kits />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'propostas',
          element: <PrivateRoute element={<Propostas />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'chamados',
          element: <PrivateRoute element={<Chamados />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'logs',
          element: <PrivateRoute element={<LogsPage />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'configuracao',
          element: <PrivateRoute element={<ConfiguracaoPage />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'agenda',
          element: <PrivateRoute element={<Agenda />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'relatorios',
          element: <PrivateRoute element={<Relatorios />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'leads',
          element: <PrivateRoute element={<HomeLeads />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
      ],
    },

    // Engenharia
    {
      path: '/',
      element: <DashboardLayoutEngenharia />,
      children: [
        {
          path: 'home2',
          element: <PrivateRoute element={<HomeEngenharia />} requiredModuleId={2} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'propostas2',
          element: <PrivateRoute element={<Propostas />} requiredModuleId={2} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'agenda2',
          element: <PrivateRoute element={<Agenda />} requiredModuleId={2} usuarioLogado={usuarioLogado} />,
        },
      ],
    },

    // Montagem
    {
      path: '/',
      element: <DashboardLayoutMontagem />,
      children: [
        {
          path: 'home3',
          element: <PrivateRoute element={<HomeMontagem />} requiredModuleId={3} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'propostas3',
          element: <PrivateRoute element={<Propostas />} requiredModuleId={3} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'agenda3',
          element: <PrivateRoute element={<Agenda />} requiredModuleId={3} usuarioLogado={usuarioLogado} />,
        },
      ],
    },

    // Vendas
    {
      path: '/vendas/',
      element: <DashboardVendas />,
      children: [
        {
          path: 'inicio',
          element: <PrivateRoute element={<DashboardPage />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'vendas',
          element: <PrivateRoute element={<Vendas />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'receitas',
          element: <PrivateRoute element={<Receitas />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'despesas',
          element: <PrivateRoute element={<Despesas />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'cadastros',
          element: <PrivateRoute element={<Cadastros />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'estoque',
          element: <PrivateRoute element={<Estoque />} requiredModuleId={4} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'relatorios',
          element: <PrivateRoute element={<Relatorios />} requiredModuleId={1} usuarioLogado={usuarioLogado} />,
        },
      ],
    },

    // OS
    {
      path: '/os/',
      element: <DashboardOs />,
      children: [
        {
          path: 'inicio',
          element: <PrivateRoute element={<HomeOs />} requiredModuleId={5} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'os',
          element: <PrivateRoute element={<Os />} requiredModuleId={5} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'kanban',
          element: <PrivateRoute element={<KanbanOs />} requiredModuleId={5} usuarioLogado={usuarioLogado} />,
        },
        {
          path: 'cronograma',
          element: <PrivateRoute element={<Cronograma />} requiredModuleId={5} usuarioLogado={usuarioLogado} />,
        }
      ],
    },

    // Leads
    {
      path: '/agencia/',
      element: <DashboardLeads />,
      children: [
        {
          path: 'inicio',
          element: <PrivateRoute element={<HomeLeads />} requiredModuleId={6} usuarioLogado={usuarioLogado} />,
        },
        /*
        {
          path: 'leads',
          element: <PrivateRoute element={<Leads />} requiredModuleId={6} usuarioLogado={usuarioLogado} />,
        },
        */

      ],
    },

    // Outros

    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/conexao" />, index: true },
        { path: 'modulos', element: <Modulos /> },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: '/nope',
      element: <SemAutorizacao />,
    },

    /*
      {
        path: '/pdf',
        element: <Pdf /> ,
      },
      */

    {
      path: '/kanban',
      element: <Kanban />,
    },
  ]);

  return routes;
}